import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";

import { Box, Grid } from "@material-ui/core";
import { fontStyleBlack, fontStyleRedEventProfile } from "../constants";
import { ButtonDanger } from "./buttons";
import "../styles.css";
import { Link } from "react-router-dom";

export const CardForm = ({
  image,
  title,
  date,
  address,
  description,
  button_text,
  style_button,
  onClick,
  joined,
  onJoinedClick,
  joined_button_text,
  id,
}) => {
  const dotifyDescription = () => {
    const screenWidth = window.innerWidth;
    const maxDescriptionLength = screenWidth < 768 ? 50 : 200;
    return description.length > maxDescriptionLength
      ? `${description.slice(0, maxDescriptionLength)}...`
      : description;
  };

  return (
    <Card className="defaultCardMargin card_adjusment">
      <Row>
        <Col md="auto" className="cardImageSection" style={{display:'flex',justifyContent:'center'}}>
          <Box width="250px">
            <Card.Img variant="top" src={image} className="card_image" />
          </Box>
        </Col>
        <Col>
          <Box>
            <Card.Title className="red bold card_body">{title}</Card.Title>
          </Box>
          <Card.Body>
            {date ? (
              <Box mb={2}>
                <span className="bold">Date: </span>
                {date}
              </Box>
            ) : null}
            {address ? (
              <Box mb={2}>
                <span className="bold">Address: </span>
                {address}
              </Box>
            ) : null}
            <Box mb={2}>
              <span className="bold"> Description: </span>
              <div
                dangerouslySetInnerHTML={{ __html: dotifyDescription() }}
                style={{ whiteSpace: "pre-wrap" }}
              />
            </Box>
          </Card.Body>
        </Col>
        <Col
          xl={3}
          lg={3}
          md={12}
          sm={12}
          xs={12}
          className="cta-event-buttons"
        >
          <Box
            display="flex"
            flexDirection={["column", "row", "column", "column"]}
            justifyContent={["start", "space-between", "space-between", "end"]}
            alignItems='center'
          >
            <Box m={2}>
              <ButtonDanger
                onClick={onClick}
                style={style_button}
                text={button_text}
                teamFullWidth
              />
            </Box>
            <br />
            {joined && (
              <Box m={2}>
                <ButtonDanger
                  onClick={onJoinedClick}
                  style={style_button}
                  text={joined_button_text}
                  teamFullWidth
                />
              </Box>
            )}
          </Box>
        </Col>
      </Row>
    </Card>
  );
};
export const CardFormIncButton = ({
  image,
  title,
  date,
  address,
  description,
  details,
  map,
  isLoggedIn,
}) => {
  return (
    <Grid container className="event-detail-info">
      <Grid item xs={12} sm={3} md={3} xl={2} lg={2}>
        <Box display="flex" justifyContent="center" alignItems="center" p={2}>
          <img
            src={image}
            alt="event"
            height={200}
            style={{ maxWidth: "100%", borderRadius: "0px" }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} sm={9} md={9} xl={10} lg={10}>
        <Box
          p={4}
          pr={[2, 2, 3, 4]}
          borderLeft="solid 1px #ddd"
          pl={[2, 2, 3, 5]}
        >
          <Box display={["block", "flex"]} mb={1}>
            {!isLoggedIn && (
              <Box
                minWidth={130}
                textAlign={["left", "right"]}
                flexGrow={1}
                className="order-sm-2"
              >
                <Link to="/events">
                  <Button
                    variant="contained"
                    disableElevation
                    style={{
                      backgroundColor: "#E00000",
                      color: "white",
                      padding: "7px 25px 8px",
                    }}
                  >
                    Join Event
                  </Button>
                </Link>
              </Box>
            )}
            <Box className="order-sm-1" style={fontStyleRedEventProfile}>
              {title}
            </Box>
          </Box>
          <Box>
            {date && (
              <Box mb={1}>
                <span style={fontStyleBlack}>Date: </span>
                {date}
              </Box>
            )}
            {address && (
              <Box mb={1}>
                <span style={fontStyleBlack}>Address: </span>
                {address}
              </Box>
            )}
            <Box mb={1}>
              <span style={fontStyleBlack}> Description: </span>
              {description}
            </Box>
            {details && (
              <Box mb={1}>
                <span style={fontStyleBlack}>Facebook event: </span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={details}
                  style={{ color: "#E00000", textTransform: "lowercase" }}
                >
                  {details}
                </a>
              </Box>
            )}
            {map && (
              <Box mb={1}>
                <span style={fontStyleBlack}>Google map: </span>
                <a
                  target="_blank"
                  href={map}
                  rel="noopener noreferrer"
                  style={{ color: "#E00000", textTransform: "lowercase" }}
                >
                  {map}
                </a>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
